import { useNavigate, useParams } from "react-router-dom";
import {
  PRESS_RELEASE_LIST_ROUTE,
  PRESS_RELEASE_UPDATE_ROUTE,
} from "constants/routeEnum";
import callApi from "Common/utils/apiCaller";
import HtmlCode from "Common/Components/HtmlCode/HtmlCode";
import * as Yup from "yup";
import { useFormik } from "formik";
import { X } from "lucide-react";
import { showNotification } from "Common/utils/Notification";
import { useEffect, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "Common/utils/ImageDomain";
import { ToastContainer } from "react-toastify";
import BreadCrumb from "Common/BreadCrumb";
import Drawer from "Common/Components/Drawer";
import ImageView from "Common/Components/ImageView/ImageView";
import ImageData from "Common/Components/customImage/Image";
import LoaderComponent from "Common/Components/Loader/Loader";
import EditableView from "../Blog/EditableSegment";
import CustomInput from "Common/Components/InputFields/CustomInput";
import NewHtmlCode from "../../Common/Components/HtmlCode/NewHtmlCode";
import MultiDropdown from "Common/Components/searchComponent/searchApi";
import MetaData from "Common/MetaData";
import moment from "moment";
import CustomDateInput from "Common/Components/InputFields/CustomDateInput";

const segment_keys = ["banner_segments"];

const UpdatePressrelease = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<any>({ released_at: "" });
  const [addHtml, setAddHtml] = useState<any>();
  const { id } = useParams();
  const [version, setVersion] = useState<any>();
  const [segmentVersion, setSegmentVersion] = useState<any>();
  const [loading, setLoading] = useState<any>(false);
  const [showApprove, setShowApprove] = useState<any>(false);
  const [segmentData, setSegmentData] = useState<any>();
  const [blogInfo, setBlogInfo] = useState<any>([]);
  const [blogData, setBlogData] = useState<any>();
  const [imageLink, setImageLink] = useState<any>();
  const [content, setContent] = useState<any>();
  const [pressreleaseData, setPressreleaseData] = useState<any>();
  const [loader, setLoader] = useState<any>(false);
  const [imageData, setImageData] = useState<any>("");
  const [collapse, setCollapse] = useState([]);
  const [metaEdit, setMetaEdit] = useState<any>({
    url: "",
    page_title: "",
    meta_description: "",
    meta_keyword: "",
    canonical_url: "",
  });
  const [errors, setErrors] = useState<any>();
  const [showMeta, setShowMeta] = useState<any>(false);
  const toggleMeta = () => setShowMeta(!showMeta);
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.content_type?.split("/")[0] === "image") {
        setImageLink(imageData);
      } else {
        showNotification("Please Select Image", "error");
      }
    }
  }, [imageData]);
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      user: profile.user,
    })
  );

  const { permission, user } = useSelector(selectProperties);

  const userHasPermissionToEditPage = () => {
    return permission?.permissions?.includes("pressrelease:edit");
  };

  const handleshowSagment = (index) => {
    if (collapse.some((item) => item === index)) {
      setCollapse(collapse.filter((item) => item !== index));
    } else {
      let array = [...collapse];
      array.push(index);
      setCollapse(array);
    }
  };

  useEffect(() => {
    async function fetchannouncement(id: any) {
      try {
        const res = await callApi(`v1/pressrelease/${id}`, "get", {});
        if (res && res?.status === "Success") {
          setBlogData(res.data.pressrelease);
          setImageLink(res.data.pressrelease);
          setPressreleaseData(res.data.pressrelease);
          setContent(res.data.pressrelease.text);
          setMetaEdit(res.data.pressrelease);
          setAddHtml({
            label: res.data.pressrelease?.additional_html_id,
            value: res.data.pressrelease?.additional_html_id,
          });
          setFormData({
            released_at: res.data.pressrelease?.released_at,
          });
        }
      } catch (e) {
        showNotification("something went wrong", "error");
      }
    }
    if (id) {
      fetchannouncement(id);
      fetchVersionList(id);
      fetchSegmentVersion(id);
    }
  }, [id, loader]);


//   useEffect(() => {
//   async function fetchannouncement(id: any) {
//     try {
//       const res = await callApi(`v1/pressrelease/${id}`, "get", {});
//       if (res && res?.status === "Success") {
//         const basicData = res.data.pressrelease;
        
//         // Fetch detailed info to get both actual and version data properly separated
//         const detailedRes = await callApi(
//           `v1/pressrelease/${basicData.url}/detailed-info`,
//           "post",
//           {}
//         );
        
//         if (detailedRes && detailedRes?.status === "Success") {
//           // Based on your API response:
//           // - pressRelease is the published/current version
//           // - pressReleaseVersionCopy is the edited version (what you're working on)
//           const publishedData = detailedRes.data.page.pressRelease;
//           const editedData = detailedRes.data.page.pressReleaseVersionCopy;
          
//           // Use editedData for the form (what user is currently editing)
//           setBlogData(editedData || publishedData);
//           setImageLink(editedData || publishedData);
//           setPressreleaseData(editedData || publishedData);
//           setContent(editedData?.text || publishedData?.text);
//           setMetaEdit(editedData || publishedData);
//           setAddHtml({
//             label: (editedData || publishedData)?.additional_html_id?._id || 
//                    (editedData || publishedData)?.additional_html_id,
//             value: (editedData || publishedData)?.additional_html_id?._id || 
//                    (editedData || publishedData)?.additional_html_id,
//           });
//           setFormData({
//             released_at: (editedData || publishedData)?.released_at,
//           });
          
//           // Use publishedData for version comparison
//           if (editedData) {
//             setVersion(publishedData); // Show published version as comparison
//           }
//         }
//       }
//     } catch (e) {
//       showNotification("something went wrong", "error");
//     }
//   }
//   if (id) {
//     fetchannouncement(id);
//     // Remove fetchVersionList since we're getting data from detailed-info
//     fetchSegmentVersion(id);
//   }
// }, [id, loader]);


  const fetchVersionList = async (id) => {
    try {
      const res = await callApi(
        `v1/pressrelease/${id}/unfrozen-copies`,
        "get",
        {}
      );
      if (res && res?.status === "Success") {
        setVersion(res.data?.copies);
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };

  const handlePublish = async (url: any) => {
    try {
      const res = await callApi(
        `v1/pressrelease/url/${url}/publish-pressrelease`,
        "get",
        {}
      );
      if (res && res?.status === "Success") {
        showNotification("Published successfully", "success");
        fetchBlog(pressreleaseData?.url);
        setShowApprove(false);
        setLoader(!loader);
      }
    } catch (e) {
      showNotification(
        e.response.data.data.message || "Error occured",
        "error"
      );
    }
  };


const handleMetaChange = (keyName, keyValue) => {
  setMetaEdit((prev) => ({
    ...prev,
    [`updated_${keyName}`]: keyValue,
    is_meta_edited: true, 
  }));
  setErrors((prev) => ({
    ...prev,
    [`updated_${keyName}`]: "",
  }));
};

  const handleValidate = (data: any) => {
    let isValid = true;
    let error: { [index: string]: any } = {};
    if (!data?.url || data?.url === "") {
      isValid = false;
      error["url"] = "Please enter url";
    }
    if (!data?.page_title || data?.page_title === "") {
      isValid = false;
      error["page_title"] = "Please enter page title";
    }
    if (!data?.meta_description || data?.meta_description === "") {
      isValid = false;
      error["meta_description"] = "Please enter meta description";
    }
    return {
      isValid,
      error,
    };
  };

  const userHasPermissionToApprovePage = () => {
    return permission?.permissions?.includes("pressrelease:verify");
  };

  const userHasPermissionToPublishPage = () => {
    return permission?.permissions?.includes("pressrelease:publish");
  };

  const handleMetaData = async () => {
    let check = handleValidate(metaEdit);
    if (check.isValid) {
      try {
        const res = await callApi(
          `v1/pressrelease/${pressreleaseData?.url}/update-pressrelease`,
          "post",
          {
            ...metaEdit,
          }
        );
        if (res && res?.status === "Success") {
          showNotification("Updated successfully", "success");
        }
      } catch (e) {
        showNotification(
          e.response.data.data.message || "Error occured",
          "error"
        );
      }
    } else {
      setErrors(check.error);
    }
  };
  const handleBannerSegment = async () => {
    try {
      const res = await callApi(`v1/normalBanner/new`, "post", {
        bannerSegmentTwo: {
          page_id: id,
          banner_image_url: "",
          banner_header_text: "",
          banner_sub_header_text: "",
        },
      });
      if (res?.status === "Success") {
        const response = await callApi(
          `v1/pressrelease/${id}/banner-segment/${res?.data?.bannerSegmentTwo?._id}/add-segment`,
          "post",
          {}
        );
        if (response?.status === "Success") {
          showNotification("Banner segment added successfully", "success");
          fetchBlog(pressreleaseData?.url);
        }
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };
  async function fetchBlog(url) {
    try {
      const res = await callApi(
        `v1/pressrelease/${url}/detailed-info`,
        "post",
        {}
      );

      if (res?.status === "Success") {
        const { banner_segments = [] } = res.data.page;

        // Formatting into the required structure
        const formattedSegments = [
          ...banner_segments.map((segment) => ({
            segment_type: "banner_segments",
            _id: segment._id,
          })),
        ];
        let newSegmentData = [];
        let page = res.data.page;
        segment_keys?.forEach((segmentKey) => {
          if (page[segmentKey] && page[segmentKey].length > 0) {
            page[segmentKey].forEach((pageSegment) => {
              newSegmentData[pageSegment._id] = {
                data: pageSegment,
                segment_type: segmentKey,
              };
            });
          }
        });
        setSegmentData(newSegmentData);
        setBlogInfo(formattedSegments);
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  }
  useEffect(() => {
    if (pressreleaseData?.url) {
      fetchBlog(pressreleaseData?.url);
    }
  }, [pressreleaseData?.url, loader]);
  const handleApprove = async () => {
    if (!pressreleaseData) {
      showNotification("Page data is missing. Please try again.", "error");
      return;
    }
    if (pressreleaseData?.url) {
      try {
        const response = await callApi(
          `v1/pressrelease/url/${pressreleaseData?.url}/approve`,
          "get"
        );
        if (response?.status === "Success") {
          setLoader(!loader);
          showNotification("Page approved successfully", "success");
          fetchBlog(pressreleaseData?.url);
          setShowApprove(true);
        }
      } catch (error) {
        showNotification(
          "An error occurred while publishing the page. Please try again.",
          "error"
        );
      }
    }
  };
  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      heading: (pressreleaseData && pressreleaseData?.heading) || "",
    },
    validationSchema: Yup.object({
      heading: Yup.string().required("Please Enter Heading"),
    }),

    onSubmit: async (values) => {
      const updateData = {
        ...values,
      };
      if (!!!imageLink?.media_url && !!!imageLink?.thumbnail_url) {
        showNotification("Please add image", "error");
        return;
      }
      if (!content) {
        showNotification("Please add text", "error");
        return;
      }

      try {
        setLoading(true);
        const res = await callApi(
          `v1/pressrelease/${pressreleaseData?.url}/update-pressrelease`,
          "post",
          {
            ...values,
            thumbnail_url: imageLink?.media_url,
            thumbnail_media_id: imageLink?._id,
            text: content,
            url: pressreleaseData?.url,
            additional_html_id: addHtml?.value ? addHtml?.value : null,
            ...formData,
          }
        );
        setLoading(false);
        if (res && res?.status === "Success") {
          showNotification("pressrelease updated successfully", "success");
          setImageLink("");
          fetchVersionList(id);
          setLoader(true);
          setTimeout(() => {
            navigate(PRESS_RELEASE_LIST_ROUTE);
            setLoader(false);
          }, 800);
        }
      } catch (e) {
        showNotification("something went wrong", "error");
      }
    },
  });

  const fetchSegmentVersion = async (id) => {
    try {
      const res = await callApi(
        `v1/pressrelease/${id}/version-list`,
        "post",
        {}
      );
      if (res && res?.status === "Success") {
        let copyObject = {};
        let copyDocuments = res.data?.documents;
        copyDocuments.forEach((objectItem) => {
          copyObject[objectItem.original_id] = objectItem;
        });
        setSegmentVersion(copyObject);
      }
    } catch (e) {}
  };

  const getSegmentData = (item) => {
    return item._id &&
      segmentData &&
      segmentData[item._id] &&
      segmentData[item._id].data
      ? {
          ...segmentData[item._id].data,
          segment_type: item.segment_type,
        }
      : null;
  };

  const getVersionCopyData = (item) => {
    return item._id && segmentVersion[item._id]
      ? {
          ...segmentVersion[item._id],
          segment_type: item.segment_type,
        }
      : null;
  };

  const handleApiChange = (keyName, keyValue) => {
    setAddHtml(keyValue);
  };

  const showError = (keyName) => {
    return errors && errors[keyName] ? (
      <p className="text-red-500 text-[14px]  pt-2">{errors[keyName]}</p>
    ) : null;
  };

  const hasEditMode = () => {
    return pressreleaseData?.is_edit;
  };

  const hasApproved = () => {
    return pressreleaseData?.is_approved;
  };

console.log('Can Publish:', userHasPermissionToPublishPage());
console.log('Show Approve:', showApprove);
console.log('Has Approved:', hasApproved());

const toLocalMidnightDate = (isoStr) => {
  if (!isoStr) return "";
  const m = moment(isoStr).local(); // convert UTC to local
  return new Date(m.year(), m.month(), m.date()); // local midnight Date object
};

const formatDateOnly = (date) => {
  return moment(date).format("YYYY-MM-DD");
};


  return (
    <>
      <div className="flex justify-between mt-2">
        <BreadCrumb
          title={PRESS_RELEASE_UPDATE_ROUTE.replace(":id", id)}
          pageTitle={PRESS_RELEASE_LIST_ROUTE}
          version="v1"
        />
        <div>
        {userHasPermissionToApprovePage() &&
            hasEditMode() &&
            !showApprove && (
            <div
              className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              onClick={handleApprove}
            >
              Approve
            </div>
          )}

          {userHasPermissionToPublishPage() && showApprove && hasApproved() && (
            <button
              type="button"
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              onClick={() => {
                handlePublish(pressreleaseData?.url);
              }}
            >
              <span className="align-middle">Publish</span>
            </button>
          )}

          <button
            type="button"
            className="ml-2 text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            onClick={() => toggleMeta()}
          >
            <span className="align-middle">Edit Meta</span>
          </button>
        </div>
      </div>
      <ToastContainer />
      {blogInfo?.map((item, index) => (
        <EditableView
          segmentType={item?.segment_type}
          key={index}
          loader={loader}
          setLoader={setLoader}
          handleshowSagment={() => handleshowSagment(index)}
          segment_id={item?._id}
          data={getSegmentData(item)}
          versionData={getVersionCopyData(item)}
          pageId={id}
          collapse={collapse}
          index={index}
          handleDelete={""}
          pageType={"pressrelease"}
          isEditable={userHasPermissionToEditPage()}
        />
      ))}
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <CustomInput
                    label="Heading"
                    name="heading"
                    type="text"
                    value={validation.values.heading}
                    placeholder="Enter heading"
                    onChange={validation.handleChange}
                    isVersioned={version?.heading ? true : false}
                    versionedValue={version?.heading}
                  />

                  {validation.touched.heading && validation.errors.heading ? (
                    <p className="text-red-400">{validation.errors.heading}</p>
                  ) : null}
                </div>
              </div>

              <div className="m-4 ml-0 xl:col-span-12">
                {imageLink ? (
                  <div className="flex items-center">
                    <ImageData
                      imageLink={imageLink}
                      setImageLink={setImageLink}
                      setImageData={setImageData}
                    />
                    <div className="h-3 ml-3">
                      <div
                        onClick={() => {
                          setImageData(undefined);
                          toggleImage();
                        }}
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        Change
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      onClick={() => {
                        setImageData(undefined);
                        toggleImage();
                      }}
                      className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      {"Add Image"}
                    </div>
                  </>
                )}
              </div>
              <NewHtmlCode
                content={content}
                setContent={setContent}
                label={"Text"}
                isVersioned={version?.text ? true : false}
                versionedValue={version?.text}
              />
              <div className="xl:col-span-12">
                <CustomDateInput
                  // value={formData?.released_at || ""} // Default to empty string if undefined
                  value={toLocalMidnightDate(formData?.released_at)} // pass local midnight Date
                  setDate={(selectedDates) => {
                      if (selectedDates && selectedDates[0]) {
                        // Save only date string YYYY-MM-DD to avoid timezone shifts
                        setFormData(prev => ({
                          ...prev,
                          released_at: formatDateOnly(selectedDates[0])
                        }));
                      }
                    }}
                  dateOptions={{ dateFormat: "Y-m-d" }}
                  isRequired={true}
                  keyName="released_at"
                  label="Release Date"
                  // setDate={(selectedDates) => {
                  //   if (selectedDates && selectedDates[0]) {
                  //     setFormData((prev) => ({
                  //       ...prev,
                  //       released_at: selectedDates[0].toISOString(),
                  //     }));
                  //   }
                  // }}
                  isVersioned={!!version?.released_at} // Only true if version.released_at is defined
                  versionedValue={
                    version?.released_at
                      ? moment(new Date(version.released_at)).toISOString()
                      : ""
                  } // Default empty string if not defined
                  placeholder="Select Date"
                  errors={""}
                />
              </div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="my-2 xl:col-span-6">
                  <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block text-base font-medium"
                  >
                    Additional Html
                  </label>
                  <MultiDropdown
                    handleApiChange={handleApiChange}
                    pageType={"additional-html"}
                    name={"additional-html"}
                    value={addHtml}
                    type="additional_htmlList"
                    id={"ddd"}
                    versionData={{
                      label: version?.additional_html_id,
                      value: version?.additional_html_id,
                    }}
                  />
                </div>
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={() => navigate(PRESS_RELEASE_LIST_ROUTE)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loader}
                  id="addNew"
                  style={{
                    minWidth: "150px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loading ? (
                    <span>
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                      />
                    </span>
                  ) : (
                    "Update Pressrelease"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Drawer
        show={showMeta}
        onHide={toggleMeta}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Edit"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <MetaData
            handleMetaChange={handleMetaChange}
            modelName="pressrelease"
            metaEdit={metaEdit}
            showError={showError}
            toggleMeta={toggleMeta}
            handleMetaData={handleMetaData}
            loader={loader}
          />
        </Drawer.Body>
      </Drawer>
      {!blogInfo.some((item) => item.segment_type === "banner_segments") && (
        <div
          onClick={() => {
            handleBannerSegment();
          }}
          className="w-[200px] my-2 text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
        >
          {"Add Banner Segment"}
        </div>
      )}
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default UpdatePressrelease;
